import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import Navbar from '../navigation/navbar';

class Objects extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
        ]).isRequired,
        appliancesByLaundryRoom: PropTypes.shape({}).isRequired,
        locationsByMansionsById: PropTypes.shape({}).isRequired,
        mansionsById: PropTypes.shape({}).isRequired,
    };

    _getReRenderFlags = () => {
        return [
            Object.keys(this.props.mansionsById).length > 0,
            Object.keys(this.props.locationsByMansionsById).length > 0,
            this.props.appliancesByLaundryRoom &&
                Object.keys(this.props.appliancesByLaundryRoom).length > 0,
        ];
    };

    render() {
        return <Navbar nav>{this.props.children}</Navbar>;
    }
}

export default connectR(
    (store) => ({
        appliancesByLaundryRoom: store.appliance.appliancesByLaundryRoom,
        locationsByMansionsById: store.locations.locationsByMansionsById,
        mansionsById: store.mansions.mansionsById,
    }),
    {}
)(Objects);
